import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 16 7",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 7\" id=\"icon-minus\"><path d=\"M.328 6.48h15.04V.72H.328v5.76Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol